import { render } from "./CreateManager.vue?vue&type=template&id=768771c9&scoped=true"
import script from "./CreateManager.vue?vue&type=script&lang=js"
export * from "./CreateManager.vue?vue&type=script&lang=js"

import "./CreateManager.vue?vue&type=style&index=0&id=768771c9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-768771c9"]])

export default __exports__